const routesConfig = {
  AUTOMATIC_CALL_PANEL: "/",
  RESET_PASSWORD_CONFIRM: "/reset-password/confirm",
  MANUAL_CALL_PANEL: "/campaigns/:campaign/students/:student_id",
  CALL_HISTORY: "/call-history/:page_slug",
} as const

export { routesConfig }
